import { Block } from '../Block'
import { styled } from '$utils/theme'
import { rem } from 'polished'
import { Link } from '$views/components/Link'
import { DropdownMenu } from '$views/components/DropdownMenu'
import { Icon } from '$views/components/Icon'

interface Props {
  visible?: boolean
}

export const HeaderWrapper = styled(Block).attrs({})<Props>`
  width: 100%;
  height: ${rem(72)};
  position: fixed;
  z-index: 2;
  background-color: white;
  border-bottom: solid 1px ${p => p.theme.colors.lightGrey};
  ${p =>
    p.theme.media.onlyMobile`
      height: ${rem(50)};
  `};
`

export const HeaderDiv = styled(Block)`
  padding: ${p => rem(p.theme.sizes.base)};
  padding-left: ${p => rem(p.theme.sizes.mini)};
  height: ${rem(71)};
  align-items: center;
  display: flex;
  position: fixed;
  width: 100%;
  z-index: 2;
  flex-direction: row;
  justify-content: space-between;
  max-width: 1160px;
  margin: auto;
  left: 0;
  right: 0;
  ${p => p.theme.media.onlyMobile`
    height: ${rem(50)};
    padding-right: ${rem(p.theme.sizes.base)};
    padding-left: ${rem(p.theme.sizes.mini)};
  `};
`

export const HeaderLogo = styled.div`
  display: inline-flex;
  flex-grow: 1;

  ${p =>
    p.theme.media.onlyMobile`
      position: relative;
      top: 2px;
      padding-left: 0;
      img {
        padding-top: 4px;
      };
      width: 23px !important;
    `};
  ${p =>
    p.theme.media.desktop`
      margin-top: 7px;
      img {
        transform: scale(1);
      }
    `};
`

export const StyledLink = styled(Link).attrs({})<Props>`
  margin-right: ${p => rem(p.theme.sizes.small)};
  text-decoration: none !important;
  ${p => p.theme.media.onlyMobile`
    margin-right: ${rem(p.theme.sizes.none)};
  `};
  &:hover {
    color: ${p => p.theme.colors.darkGrey} !important;
    text-shadow: 0ex 0 ${p => p.theme.colors.darkGrey}, 0.08ex 0 ${p => p.theme.colors.darkGrey};
  }
`

export const StyledDropDown = styled(DropdownMenu)`
  color: ${p => p.theme.colors.darkGrey} !important;
  text-shadow: -0.06ex 0 ${p => p.theme.colors.darkGrey}, 0.08ex 0 ${p => p.theme.colors.darkGrey};
`

export const StyledBlock = styled(Block)`
  position: relative;
  top: 3px;
`

export const PremiumImage = styled(Icon)`
  position: relative;
  top: ${p => rem(p.theme.sizes.tiny)};
  ${p => p.theme.media.onlyMobile`
    top: -${rem(p.theme.sizes.tiny)};
  `}
`

export const PremiumProImage = styled(Icon)`
  position: relative;
  ${p => p.theme.media.onlyMobile`
    top: -${rem(p.theme.sizes.tiny)};
  `}
`



// WEBPACK FOOTER //
// ./src/views/components/Layout/HomeHeader/HomeHeader.style.ts